import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { url } from '../constants/url';
import { fetchClientUserList } from '../Client-components/API/Message/messageAPI';
import { fetchISECURIONUserList } from '../Isecurion-components/API/messageAPI';

const UserContext = createContext();

export const UserAuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [emailVer, setEmailVer] = useState('');
    const [userRole, setUserRole] = useState('');
    const [userPermission, setUserPermission] = useState('')
    const [isOnline, setIsOnline] = useState(false);
    const [isUpdated, setIsUpdated] = useState(false);
    const [company, setCompany] = useState('')
    const [multifactor, setMultifactor] = useState(null)
    const [mfaTour, setMfaTour] = useState(null)
    const navigate = useNavigate();
    const [showDemo, setShowDemo] = useState(false)

    const [count, setCount] = useState(0)
    const [isecCount, setISECCount] = useState(0)


    const [notificationData, setNotificationData] = useState([])
    const [notificationCount, setNotificationCount] = useState(0)


    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isecSidebarCollapsed, setIsecSidebarCollapsed] = useState(false);

    const toggleSidebar = () => setIsSidebarCollapsed((prev) => !prev);

    const isecToggleSidebar = () => setIsecSidebarCollapsed((prev) => !prev);

    const handleDemo = () => {
        setShowDemo(!showDemo)
    }
    const onClose = () => {
        setShowDemo(false)
    }



    // Refer users.js file for backend code
    const checkAuth = async () => {
        try {
            const response = await axios.get(`${url}/verifyToken`, { withCredentials: true });

            if (response.status === 200 && response.data.token) {
                setIsAuthenticated(true);
                setUser(response.data.name);
                setEmailVer(response.data.email)
                setUserRole(response.data.role)
                setUserPermission(response.data.permission)
                setIsOnline(response.data.status)
                setCompany(response.data.companyName)
                setMultifactor(response.data.mfa)
                setMfaTour(response.data.mfaTour)
                fetchNotification()
                return
            }
            if (response.status === 440) {
                setIsAuthenticated(false);
                setUser(null);
                setUserRole(null)
                setUserPermission(null)
                setIsOnline(response.data.status)
                setMultifactor(null)
                setMfaTour(null)
                toast.error("User logout due to inactivity", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                logout()
                return
            }
        } catch (error) {
            setIsAuthenticated(false);
            setUser(null);
            logout()
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const currentPath = window.location.pathname;
        if (isAuthenticated && (currentPath === '/' || currentPath === '/login')) {
            if (/\b@isecurion\.com$/.test(emailVer)) {
                navigate('/isecurion_dash');
            } else {
                navigate('/client_dashboard');
            }
        }
    }, [isAuthenticated, emailVer, navigate]);

    useEffect(() => {
        checkAuth();
        if (!isAuthenticated) return;


        const fetchData = async () => {
            await fetchNotification();
        };
        fetchData();
        const intervalId = setInterval(() => {
            fetchData();
        }, 120000);
        return () => clearInterval(intervalId);
    }, [emailVer]);



    // Refer users.js file for backend code
    const login = async (email, password) => {
        try {
            const response = await axios.post(`${url}/login`, { email, password }, { withCredentials: true });
            if (response.data.token) {
                setIsAuthenticated(true);
                setUser(response.data.name);
                setEmailVer(response.data.email)
                setUserRole(response.data.role)
                setUserPermission(response.data.permission)
                setIsOnline(response.data.status)
                setIsUpdated(response.data.isUpdated)
                setCompany(response.data.companyName)
                setMultifactor(response.data.mfa)
                setMfaTour(response.data.mfaTour)
                checkAuth()
            } else {
                setMultifactor(response.data.mfa)
            }
            return response
        } catch (error) {

            toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 5000,
                pauseOnHover: false,
            });
            throw error
        }
    };

    const verifyOTP = async (email, otp) => {
        try {
            const response = await axios.post(`${url}/verifyotp`, { email, otp }, { withCredentials: true });
            if (response.data.token) {
                setIsAuthenticated(true);
                setUser(response.data.name);
                setEmailVer(response.data.email)
                setUserRole(response.data.role)
                setUserPermission(response.data.permission)
                setIsOnline(response.data.status)
                setIsUpdated(response.data.isUpdated)
                setCompany(response.data.companyName)
                setMultifactor(response.data.mfa)
                setMfaTour(response.data.mfaTour)
                checkAuth()
            }

        } catch (error) {
            toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 5000,
                pauseOnHover: false,
            });
            throw error
        }
    }

    const fetchNotification = async () => {
        try {
            const response = await fetch(`${url}/fetchnotification`, {
                method: "GET",
                credentials: 'include'
            });
            const data = await response.json();

            if (data.notifications) {
                const unreadCount = data.notifications.filter(notification => notification.read !== true).length;
                setNotificationData(data.notifications);
                setNotificationCount(unreadCount);
                return
            }
            if (response.status === 440) {
                logout()
                toast.error("User logout due to inactivity", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                return
            }
        } catch (error) {

        }
    };

    // Refer users.js file for backend code
    const logout = async () => {
        try {
            const response = await axios.post(`${url}/logout`, {}, { withCredentials: true });
            setIsAuthenticated(false);
            setIsOnline(false);
            setUser(null);
            setUserRole(null)
            setUserPermission(null)
            setMultifactor(null)
            setMfaTour(null)

            toast.success(response.data.message, {
                position: "top-center",
                autoClose: 3000,
                pauseOnHover: false,
            });
            navigate('/');

        } catch (error) {
            console.log(error)
        }
    };

    // API to fetch navbar count for clientSide
    const fetchUnreadMessageCount = async () => {
        try {
            const result = await fetchClientUserList()
            if (!result) return;
            const { status, data } = result;
            if (status === 200) {
                const uniqueEmails = Array.from(
                    new Map(data.map(item => [item.email, item])).values()
                );
                const totalUnread = uniqueEmails.reduce(
                    (sum, item) => sum + (item.unreadCount || 0),
                    0
                );

                setCount(totalUnread)
            }

        } catch (error) {
            console.error('Error fetching client messages:', error);
            return null;
        }
    }

    // API to fetch navbar count for ISECURION side
    const fetchUnreadISECURIONMessageCount = async () => {
        try {
            const result = await fetchISECURIONUserList()
            // console.log(result)
            if (!result) return;
            const { status, data } = result;
            if (status === 200) {
                const uniqueEmails = Array.from(
                    new Map(data.users.map(item => [item.email, item])).values()
                );
                const totalUnread = uniqueEmails.reduce(
                    (sum, item) => sum + (item.unreadCount || 0),
                    0
                );
                setISECCount(totalUnread)
            }

        } catch (error) {
            console.error('Error fetching Isecurion user:', error);
            return null;
        }
    }

    return (
        <UserContext.Provider value={{
            isAuthenticated, user, loading, login, logout, emailVer, checkAuth,
            userRole, userPermission, isOnline, isUpdated, fetchNotification,
            notificationCount, notificationData, company, isSidebarCollapsed,
            toggleSidebar, isecSidebarCollapsed, isecToggleSidebar, handleDemo,
            onClose, showDemo, setIsSidebarCollapsed, fetchUnreadMessageCount,
            count, fetchUnreadISECURIONMessageCount, isecCount, multifactor, verifyOTP, mfaTour
        }}>
            {children}
        </UserContext.Provider>
    );
};

export const useAuth = () => useContext(UserContext);


